namespace TabAurous.Stock {
    export namespace JewelleryService {
        export const baseUrl = 'Stock/StockJewellery';

        export declare function List(request: ReportFiltersRequest, onSuccess?: (response: Serenity.ListResponse<StockItemRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            List = "Stock/StockJewellery/List"
        }

        [
            'List'
        ].forEach(x => {
            (<any>JewelleryService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
